import { useEffect, useState } from "react";
import { IoHomeOutline } from "react-icons/io5";
import { getAccountAddressAsync } from "../../../../../services/accountService";
import DescriptionList from "../../../../../components/common/DescriptionList";
import Modal from "./../../../../../components/common/Modal";
import AddressForm from "./AddressForm";

const AddressInformation = ({ id }) => {
  const [address, setAddress] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchAddress = async () => {
      setIsLoading(true);

      const result = await getAccountAddressAsync(id);

      if (mounted) {
        setAddress(result);
        setIsLoading(false);
      }
    };

    fetchAddress();

    return () => {
      mounted = false;
    };
  }, [id, refresh]);

  const renderAddress = () => {
    let primary_address = "-";

    if (address) {
      const {
        address_line1,
        address_line2,
        street,
        barangay,
        city,
        province,
        zip_code,
      } = address;

      const line_1 = address_line1 ? address_line1 : "";
      const line_2 = address_line2 ? address_line2 : "";

      primary_address = `${line_1} ${line_2} ${street}, ${barangay}, ${city}, ${province} ${zip_code}`;
    }

    return primary_address;
  };

  const handleSuccess = () => {
    setShowForm(false);
    setRefresh(!refresh);
  };

  return (
    <div className="p-5">
      <div className="mt-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <IoHomeOutline className="mr-3 text-3xl text-gray-300" />
            <div>
              <p className="text-gray-500">Address Information</p>
              <span className="text-xs text-gray-400">Address Details</span>
            </div>
          </div>
          <button
            className="text-blue-500 text-sm"
            onClick={() => setShowForm(true)}
          >
            Edit
          </button>
        </div>
      </div>
      <div className="px-12 py-5 space-y-7">
        <div className="grid grid-cols-2">
          <DescriptionList
            label="Primary Address"
            className="col-span-2"
            content={renderAddress()}
            isLoading={isLoading}
          />
        </div>
      </div>
      <Modal
        title="Address Information"
        isOpen={showForm}
        isLoading={isFormLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <AddressForm
          id={id}
          data={address}
          isLoading={isFormLoading}
          setLoading={setIsFormLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </div>
  );
};

export default AddressInformation;
